import { MOBILE_STICKY_PLAN_AND_CYCLE_SPEC } from './consts';
export const isMobileStickyPlanAndCycleEnabled = _ref => {
  let {
    experiments,
    isMobile
  } = _ref;
  return isMobile && experiments.isEnabled(MOBILE_STICKY_PLAN_AND_CYCLE_SPEC);
};
//# sourceMappingURL=isMobileStickyPlanAndCycleEnabled.js.map